import { useState, useMemo } from "react";
import { TextareaAutosize, Grid, Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import SurveyService from "../Services/SurveyService";
import { useTranslation } from "react-i18next";
import QuestionModel from "../Models/Survey/Questions/QuestionModel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

export default function DateAnswer(props: {
  questionModel: QuestionModel;
  surveyId: string;
  setQuestionModel: Function;
  setIsFirstQuestion: Function;
  setCurrentQuestionId: Function;
  setLoading: Function;
}) {
  const { t, i18n } = useTranslation("survey");

  const surveyService = useMemo(() => new SurveyService(), []);
  const [dateValue, setDateValue] = useState<Dayjs | null>(dayjs());
  const [dateValueAsString, setDateValueAsString] = useState<string>(
    dayjs().format("YYYY-MM-DD"),
  );
  const [dateError, setDateError] = useState<string | null>(null);

  if (props.questionModel !== undefined) {
    return (
      <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={t("Datum")}
            value={dateValue}
            inputFormat="DD/MM/YYYY"
            onChange={(newValue) => {
              setDateValue(newValue);

              if (!newValue) {
                setDateValueAsString("");
                setDateError(t("Het veld mag niet leeg zijn"));
                return;
              }

              setDateValueAsString(newValue.format("YYYY-MM-DD"));
              setDateError(null);
            }}
            onError={(reason) => {
              if (reason === "invalidDate") {
                setDateError(t("Ongeldig datumformaat"));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={Boolean(dateError)}
                helperText={dateError}
              />
            )}
          />
        </LocalizationProvider>

        <Grid justifyContent="center" container p={3}>
          <Button
            className="float-start"
            variant="contained"
            key={props.questionModel.id}
            style={{
              textTransform: "none",
              maxWidth: "100%",
            }}
            onClick={() => clickAnswer()}
          >
            {t("Volgende vraag")}
          </Button>
        </Grid>
        {props.questionModel.imageBase64String && (
          <img
            src={`data:${props.questionModel.imageType};base64,${props.questionModel.imageBase64String}`}
            alt="Vraag afbeelding"
            style={{
              marginTop: "1rem",
              width: "auto",
              height: "350px",
              display: "block",
            }}
          />
        )}
      </>
    );
  }

  return <></>;

  function clickAnswer() {
    if (props.questionModel) {
      if (!dateError) {
        props.setLoading(true);
        surveyService
          .saveAnswer(
            {
              surveyId: props.surveyId,
              questionId: props.questionModel.id,
              answer: dateValueAsString,
              nextQuestionId: null,
              possibleAnswerId: null,
            },
            i18n.language,
          )
          .then((result) => {
            if (result) {
              if (result.success) {
                //do stuff with question
                if (result.nextQuestionModel !== null) {
                  //set Progress bar
                  props.setQuestionModel(result.nextQuestionModel);
                  props.setIsFirstQuestion(
                    result.nextQuestionModel.thisIsTheFirstQuestion,
                  );
                  props.setCurrentQuestionId(result.nextQuestionModel.id);
                }
              } else {
                toast.error(t("Fout bij opslaan van vraag."));
              }
            }
            props.setLoading(false);
          });
      }
    }
  }
}
